<full-modal-config
    modalTitle="{{ (editable.id ? l10nKeys.modalTitleEdit : l10nKeys.modalTitleNew) | vtranslate }}"
    modalSubTitle="{{ editable.getName() }}"
    [modified]="form.touched && form.dirty"
    (onCancel)="editable.dismiss(true)"
    (onSubmit)="editable.submit()"
    [busy]="editable.isBusy()"
    [errors]="editable.errors"
    [valid]="form.valid"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        #form="ngForm"
    >
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleGeneral | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleGeneral | vtranslate }}</h3>
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        objectType="{{ objectType }}"
                        fieldName="name"
                        for="name"
                        required
                    >
                        {{ l10nKeys.nameInputLabel | vtranslate }}
                    </label>
                    <input
                        id="name"
                        name="name"
                        [(ngModel)]="editable.config.name"
                        clrInput
                        placeholder="{{ l10nKeys.namePlaceholder | vtranslate }}"
                        regexPattern="objName"
                        required
                    />
                </avi-input-container>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectType }}"
                            fieldName="run_script_uuid"
                            for="run_script_uuid"
                            required
                        >
                            {{ l10nKeys.controlScriptInputLabel | vtranslate }}
                        </label>
                        <avi-collection-dropdown
                            [collection]="controlScriptCollection"
                            [(ngModel)]="editable.getConfig().run_script_ref"
                            name="run_script_uuid"
                            placeholder="{{ l10nKeys.controlScriptPlaceholder | vtranslate }}"
                            required
                        ></avi-collection-dropdown>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>

        <full-modal-tab-section tabTitle="{{ l10nKeys.customSectionLabel | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.customSectionLabel | vtranslate }}</h3>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <certificate-management-custom-params-grid
                            [scriptParamsList]="editable.scriptParams"
                            (onAddScriptParam)="onAddScriptParam()"
                            (onEditScriptParam)="onEditScriptParam($event)"
                            (onRemoveScriptParam)="onRemoveScriptParam($event)"
                        ></certificate-management-custom-params-grid>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
    </form>
</full-modal-config>
